import React from 'react';
import { ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';
import { callToActions } from '../../mock';
import { iconMap } from './iconMap';

export const CallToAction = ({ scrollToSection }) => (
  <section id="get-started" data-testid="cta-section" className="fade-in-section py-12 md:py-20 px-4 bg-gradient-to-b from-warmBeige/80 to-white/80 backdrop-blur-sm relative z-10">
    <div className="container mx-auto">
      <div className="text-center mb-10 md:mb-16">
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-darkBrown mb-4">You Are Our Top Priority</h2>
        <p className="text-sm md:text-xl text-gray-600">Let's Get Started</p>
        <div className="w-24 h-1 bg-primaryOrange mx-auto mt-4"></div>
      </div>

      <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-16">
        {callToActions.map((cta, index) => {
          const Icon = iconMap[cta.icon];
          return (
            <Card
              key={cta.id}
              className="border-none shadow-lg hover:shadow-2xl transition-all hover:-translate-y-2 bg-white"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <CardHeader className="p-4 md:p-6">
                <div className="w-12 h-12 md:w-16 md:h-16 bg-primaryOrange rounded-full flex items-center justify-center mb-3 md:mb-4 mx-auto">
                  <Icon className="text-white" size={24} />
                </div>
                <CardTitle className="text-darkBrown text-lg md:text-2xl text-center">{cta.title}</CardTitle>
              </CardHeader>
              <CardContent className="text-center p-4 pt-0 md:p-6 md:pt-0">
                <CardDescription className="text-gray-600 mb-4 md:mb-6 text-xs md:text-sm">{cta.description}</CardDescription>
                <Button
                  className="bg-primaryOrange hover:bg-accentOrange text-white w-full"
                  onClick={() => scrollToSection('contact')}
                >
                  Get Started
                  <ChevronRight className="ml-2" size={18} />
                </Button>
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  </section>
);
